import React from 'react';
import { Link } from 'react-router';

const NoMatch = () => (
  <div style={{ minHeight: '600px', textAlign: 'center' }}>
    <h1 style={{ fontSize: '65px', display: 'block', color: '#aaa' }}>404</h1>
    <h2>Page could not be found.</h2>

  </div>
);

export default NoMatch;



// WEBPACK FOOTER //
// ./src/pages/NoMatch.js